// extracted by mini-css-extract-plugin
export default {"wrap":"PlanNameWithProject_wrap__ZbQ5e","name":"PlanNameWithProject_name__kPvmb"};